export interface Companies {
   
    companyId: number,
    companyName: string,
    address: string,
    phone: string,
    recipientCode: string,
    city: string;
    state: string;
    country: string;
    zip: string;

}

export interface Users {
   
    id: number|null,
    firstname: string,
    lastname: string,
    email: string,
    usertype: string,
    created: string|null;
    createdBy: string|null;
    remarks: string|null;
    companyId: number,
    companyName: string;
    enabled:string;
    name: string;
}
export function emptyUsers(): Users {
  return {
      id: null,
      firstname: '',
      lastname:  '',
      email:  '',
      usertype:  '',
      created:  null,
      createdBy: null,
      remarks:  null,
      companyId: -1,
      companyName: '',
      enabled:'',
      name: ''
  }};


export function emptyCompanies(): Companies{
  return { 
  companyId: 0,
  companyName: '',
  address: '',
  phone: '',
  recipientCode: '',
  city: '',
  state: '',
  country: '',
  zip: ''
  }
}
export interface UserTypeItem {
    text: string;
    value: string;
  }

      export function usersDefault(): UserTypeItem {
    return {
      text: 'Select User Type...',
      value: '',
    }};
    
  export interface AccessTypeItem {
    text: string;
    value: number;
  }
  export interface CompaniesItem {
    text: string;
    value: number;
  }
  export function companiesDefault(): CompaniesItem {
    return {
      text: 'Select Company...',
      value: -1,
    }};

  export interface Projects {
    projectId:number|null;
    projectname: string;
    projectnumber: string;
    idocs_project_number: string|null;
    idocs_project_id: number|null;
    location: string;
    active:string;
    
  }

  export interface PortalLog {
   
    logId: number,
    timestamp:string,
    projectName: string,
    //upload: any,
    portalObjectName: string,
    userName: string,
    companyName: string;
    object: string;
    action: string;
    description: string;
    loggedInUserName: string;

  }


  export interface SearchLog {
    search: string;
    startDate: Date | null;
    endDate: Date | null;
  }

  
export function emptySearchLog(): SearchLog {
  return {
    search: '',
    startDate: null,
    endDate: new Date() 
  };
}



  export function emptyProjects(): Projects {
    return {
      projectId: null,
      projectname: '',
      projectnumber:  '',
      idocs_project_number:  '',
      idocs_project_id: null,
      location: '',
      active:  '',
    }};

    export interface Objects {
      id:number|null;
      projectId: number;
      name: string;
      description: string;
      objectType: string;
      companyName:string;
      companyId:number;
      enabled: string;

    }
    export function emptyObjects(): Objects {
      return {
        id: null,
        projectId: -1,
        name: '',
        description:  '',
        objectType:  'Purchase Order',
        companyName:'',
        companyId:-1,
        enabled: 'T',
      
      }};

      export interface AccesObjects {
        id: number;
        objectId: number|null;
        name: string;
        description: string;
        userId:number|null;
        firstname: string;
        lastname: string;
        email: string;
        accesId:number|null;
        accessName: string;
        accessDescr: string;
        enabled: string;
        uploadDate: string;
        userType:string;
        company:string;

      }
      export function emptyAccessObjects(): AccesObjects {
        return {
          id: -1,
          objectId: null,
          name: '',
          description:  '',
          userId:null,
          firstname:  '',
          lastname:  '',
          email:  '',
          accesId:null,
          accessName:  '',
          accessDescr:  '',
          enabled: 'T',
          uploadDate: '',
          userType: '',
          company:''
 
        
        }};

  
export interface UserAccessDetailsDTO {
  userId: number;
  projectName: string;
  orderList: PortalAccess[];
}

export interface CopyUserAccess {
        projectId: number;
        fromUserId: number;
        toUserId: number;
}

 export function emptyCopyUserAccess(): CopyUserAccess {
        return {
          projectId: -1,
          fromUserId: -1,
          toUserId: -1
        }}

export interface PortalAccess {
  [orderName: string]: string; // e.g., "PO-101": "VIEW"
}

export interface OrderUserValidationDTO {
  objectId:number;
	name: string;
	description: string;
	userId: string;
	accessName: string;
}


// export const PROJECT_PORTAL_OBJECTS = [
//     {
//         id: 1,
//         projectId: 678,
//         projectName: 'TEST',
//         objectType: 'Purchase Order',
//         name: 'PO NUMBER 1',
//         description: 'Long description for PO1',
//         created: new Date()
//     },
//     {
//         id: 2,
//         projectId: 678,
//         projectName: 'TEST',
//         objectType: 'Purchase Order',
//         name: 'PO NUMBER 2',
//         description: 'Long description for PO1',
//         created: new Date()
//     },
//     {
//         id: 3,
//         projectId: 679,
//         projectName: 'OFF-TEST1',
//         objectType: 'Purchase Order',
//         name: 'PO NUMBER 1',
//         description: 'Long description for PO1',
//         created: new Date()
//     },
//     {
//         id: 4,
//         projectId: 679,
//         projectName: 'OFF-TEST1',
//         objectType: 'Purchase Order',
//         name: 'PO NUMBER 2',
//         description: 'Long description for PO1',
//         created: new Date()
//     },
//     {
//         id: 5,
//         projectId: 679,
//         projectName: 'OFF-TEST1',
//         objectType: 'Purchase Order',
//         name: 'PO NUMBER 2',
//         description: 'Long description for PO1',
//         created: new Date()
//     },
//     {
//         id: 6,
//         projectId: 679,
//         projectName: 'OFF-TEST1',
//         objectType: 'Purchase Order',
//         name: 'PO NUMBER 2',
//         description: 'Long description for PO1',
//         created: new Date()
//     },
//     {
//         id:7,
//         projectId: 679,
//         projectName: 'OFF-TEST1',
//         objectType: 'Purchase Order',
//         name: 'PO NUMBER 2',
//         description: 'Long description for PO1',
//         created: new Date()
//     }, {
//         id: 8,
//         projectId: 679,
//         projectName: 'OFF-TEST1',
//         objectType: 'Purchase Order',
//         name: 'PO NUMBER 2',
//         description: 'Long description for PO1',
//         created: new Date()
//     }
    
// ]